<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData[0],
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData[0] = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RefNumForm from "../../../components/payroll/referencenumbersetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";


export default {
  components: {
    "app-form": RefNumForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('setupcompanyreferencenumber.editreferencenumber'),
      pageTitleValue: "",
      formData: [],
      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
      userid: this.$store.getters.userId,
    };
  },

  methods: {
    deleteHandler($event) {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      //add div and change v-on delete
      this.isConfirm = !this.isConfirm;

      if ($event) {
        this.$store.dispatch('delete', {url:
              "/refnum/" +
              this.id +
              "/" +
              this.formData[0].userid})
          .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "refnumlist" });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
          });
      }
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    createHandler() {
      this.$router.push({ name: "refnumnew" });
    },

    cancelHandler() {
      this.$router.push({ name: "refnumlist" });
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      var payload = this.formData[0];

      //req to update record
      this.$store.dispatch('put', {url: "/refnum/" + vm.id, payload: payload})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "refnumlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    //load refnum by id
    loadRefNumHandler() {
      const vm = this;

      //req record by id
      return this.$store.dispatch('get', {url: "/refnum/" + vm.id})
        .then((res) => {
          console.log("record", res.data.rec);

          // if (res.status == 200) {
            vm.formData = res.data.rec;

             vm.formData.lockstaff = res.data.rec[0].lockstaff;
             vm.formData.adrmasdesc = res.data.rec[0].adrmasdesc;
             vm.formData.compnycode = res.data.rec[0].compnycode;
             vm.formData.remark = res.data.rec[0].remark;
            //vm.pageTitleValue = vm.formData[0].compnyname;
            // console.log("adrmasdesc",vm.formData.adrmasdesc);
            // console.log('compnycode', vm.formData.compnycode);

            console.log('remarks1', vm.formData.remark)

             vm.formData[0].userid = this.$store.getters.userId;

            vm.loading = !vm.loading;
          // } else {
          //   vm.isErr = !vm.isErr;
         // }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    await this.loadRefNumHandler();
  },
};
</script>
